// Bridges the legacy gRPC-style metadata (filters / pagination passed as
// JSON-stringified strings with snake_case keys) to the camelCase query params
// the ssp-back REST SDK expects. Shared by the projects REST stores so the
// conversion is defined once.

const snakeToCamel = (s) => s.replace(/_+([a-z0-9])?/g, (_, c) => (c ? c.toUpperCase() : ""));

const camelizeInto = (filters, params) => {
  for (const [key, value] of Object.entries(filters)) {
    if (value === undefined || value === null || value === "") continue;
    params[snakeToCamel(key)] = value;
  }
};

// Plain filter object (snake_case keys) → camelCase SDK params.
export const filtersToParams = (filters = {}) => {
  const params = {};
  camelizeInto(filters, params);
  return params;
};

// Legacy metadata ({ filters, pagination } as JSON strings or objects) →
// camelCase SDK params, including page / pageSize.
export const metadataToParams = (metadata = {}) => {
  const params = {};
  if (metadata?.filters) {
    try {
      const filters =
        typeof metadata.filters === "string" ? JSON.parse(metadata.filters) : metadata.filters;
      camelizeInto(filters, params);
    } catch {
      /* not valid JSON: ignore */
    }
  }
  if (metadata?.pagination) {
    try {
      const pagination =
        typeof metadata.pagination === "string"
          ? JSON.parse(metadata.pagination)
          : metadata.pagination;
      if (pagination.page != null) params.page = pagination.page;
      if (pagination.page_size != null) params.pageSize = pagination.page_size;
    } catch {
      /* ignore */
    }
  }
  return params;
};
